export default __webpack_public_path__ + "static/media/calendar.9d564696.svg";